export default "__VITE_ASSET__iwxhUN8v__"